export const gettingStartedMarkdown = `# Getting Started

This guide helps external ERP providers connect to CimmplePay quickly.

## 1) Environments

Define environment URLs before integration:

- \`Sandbox API Base URL\` (recommended for development/testing)
- \`Production API Base URL\`

If your deployment exposes Swagger, confirm:

- \`{baseUrl}/swagger\`
- \`{baseUrl}/swagger/v1/swagger.json\`

## 2) API style

- Protocol: HTTPS
- Format: JSON
- Auth: Bearer JWT token (see \`authentication.md\`)
- Main route pattern: \`/api/{controller}/{action}\`

## 3) First successful call

After obtaining a token, test a health endpoint:

- \`GET /api/health\`

Expected response shape:

\`\`\`json
{
  "status": "healthy",
  "timestamp": "2026-01-01T12:00:00Z",
  "version": "1.0.0",
  "environment": "Production"
}
\`\`\`

## 4) Integration minimum data you need

At minimum, your ERP integration should maintain:

- cimmplepay company id
- employee id mapping (ERP employee id <-> CimmplePay employee id)
- payroll run id mapping
- last sync timestamps

## 5) Recommended partner rollout

1. Connect in sandbox with read-only endpoints.
2. Validate employee and payroll data mapping.
3. Enable write operations (create/update/process/finalize payroll).
4. Run parallel payroll for at least one cycle.
5. Go live in production.

## 6) Support payload for debugging

When contacting support, include:

- endpoint and method
- request body (with sensitive fields masked)
- response status and response body
- timestamp (UTC)
- partner system reference id
`;
